import setLocal from './set-local';

import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

let setting = false;

export default function setKeyPair() {
  if (setting) return;
  setting = true;
  return new Promise((resolve, reject) => {
    sendAxios({
      method: 'get',
      url: `/async/crypto/info`,
      baseURL: Domains.lcscWwwUrl,
    })
      .then(async (res) => {
        if (res.code === 200) {
          const keyPair = res || {};
          if (keyPair.decryptPrivateHexKey && keyPair.encryptPublicHexKey) {
            setLocal('keyPair', keyPair);
          }
          resolve(keyPair);
        }
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {
        setting = false;
      });
  });
}
